import { message } from 'antd';
import axios from 'axios';

export default Request = (option) => {
  return new Promise((resolve, reject) => {
    axios({
      url: option.url,
      method: option.method,
      //baseURL: "http://192.168.1.250:18081/api/",
      baseURL: "https://api.user.tdsm.vip/api/",
      params: option.data || null,
      timeout: 10000,
      withCredentials: true,
    }).then((response) => {
      let data = response.data;
      if (data.code === 200) {
        resolve(data.result);
      } else {
        message.error(data.msg)
        reject(data.result);
      }
    });
  });
};